import React, { useEffect, useState } from "react";
import LectureCard from "../components/LectureCard";

const Lectures = ({
  token,
  user,
  role,
  loading,
  lectures,
  setActiveButton,
  setLectureToView,
  handleLectureClick,
  setLectures,
  activeButton,
  fetchLectures,
}) => {
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const [batches, setBatches] = useState([]);

  const fetchBatches = async (activeBatch) => {
    try {
      const response = await fetch(`${SERVER_URL}/batch/${activeBatch}`, {
        method: "GET",
        // mode: "cors",
        headers: {
          "Content-Type": "application/json",
          authorization: `${token}`,
        },
      });
      if (response.status === 200) {
        const res = await response.json();
        const onlyBatch = res.map((batch) => batch.batch);
        setBatches(onlyBatch);
      } else {
        const res = await response.json();
        alert(res.message);
        // Handle other response codes or errors here
        console.error("Data Retreieval:", res.message);
      }
    } catch (error) {
      // Handle network errors or other exceptions
      console.error("Retreieval failed:", error);
    }
  };

  useEffect(() => {
    fetchBatches("PGP");
  }, []);

  if (loading) {
    return (
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-gray-100 bg-opacity-70 flex items-center justify-center backdrop-blur">
        <div className="p-4 bg-white rounded-lg shadow-lg flex items-center space-x-4">
          <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500"></div>
          <p className="text-2xl tracking-[.1em] font-medium text-gray-700">
            Loading{" "}
            <span className="loading loading-dots tracking-[.2em] loading-xs align-bottom"></span>
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="shadow-none p-2 w-[100%]" bkl="Lectures" key="Lectures">
      <div
        className="flex flex-col gap-2 w-full mx-auto "
        key={"LectureCardList"}
      >
        {lectures.map((item, index) => (
          <LectureCard
            role={role}
            lecture={item}
            index={index}
            onclickOpenLecture={() => handleLectureClick(item)}
            activeButton={activeButton}
          />
        ))}
      </div>

      {lectures.length === 0 && (
        <div className="flex flex-col items-center justify-center w-[100%]">
          <div className="p-4 bg-white rounded-lg shadow-lg flex flex-col items-center justify-center w-full max-w-[90%] md:max-w-md">
            <div className="text-5xl mb-4">
              <i className="fas fa-exclamation-circle text-yellow-500"></i>
            </div>
            <h2 className="text-2xl font-semibold text-gray-700">
              Oops! No Lectures Found
            </h2>
            <p className="mt-2 text-gray-500">
              It seems there are no lectures available at the moment.
            </p>
            <button
              className="mt-4 tracking-[.05em] bg-blue-500 text-white px-4 py-2 rounded-md shadow hover:bg-blue-600 transition duration-200"
              onClick={() => {
                setActiveButton("all");
              }}
            >
              See All
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Lectures;
